import { render, staticRenderFns } from "./CurriculamSection.vue?vue&type=template&id=53eeabba"
import script from "./CurriculamSection.vue?vue&type=script&lang=js"
export * from "./CurriculamSection.vue?vue&type=script&lang=js"
import style0 from "./CurriculamSection.vue?vue&type=style&index=0&id=53eeabba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports